module.exports = kolibriGlobal.coreVue.mixins.responsiveWindow;